var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('Button',{staticStyle:{"width":"90px"},attrs:{"loading":_vm.loading,"icon":_vm.icon,"type":"primary"},on:{"click":_vm.onClick}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.label)+" ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }